import storyJson from "./story.json";
import { iconsAndImages } from "../../assets/images";
import "./storyStyle.scss";

export const Story = () => {
    return (
        <section className="story-section py-5">
            <div className="container">
                <div className="row align-items-center gy-5">
                    <div className="col-12 col-lg-6 order-1 order-lg-1">
                        <div className="story-img-wrap animate-left">
                            <img
                                loading="lazy"
                                src={iconsAndImages?.[storyJson?.image]}
                                alt="story"
                                className="img-fluid w-100 rounded-4 shadow story-img"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 order-2 order-lg-2">
                        <div className="story-content animate-right">
                            <span className="story-info">
                                {storyJson?.info}
                            </span>
                            <h1
                                className="bebas-neue-regular story-title"
                                dangerouslySetInnerHTML={{ __html: storyJson?.title }}
                            />
                            <p
                                className="story-desc"
                                dangerouslySetInnerHTML={{ __html: storyJson?.subContent1 }}
                            />
                            <p
                                className="story-desc mb-4"
                                dangerouslySetInnerHTML={{ __html: storyJson?.subContent2 }}
                            />
                            <div className="row text-center text-lg-start">
                                {storyJson?.storyDetails?.map((details, index) => (
                                    <div className="col-6 col-md-4 mb-3" key={index}>
                                        <h4 className="bebas-neue-regular text-color mb-1">
                                            {details?.value}
                                        </h4>
                                        <p className="small fw-semibold mb-0">
                                            {details?.name}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};